import {
  Component,
  OnInit,
  Input,
  ComponentFactoryResolver
} from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { DataEntity } from '../../../../../models/data-entities';
import { FreeFormTextDataEntity } from 'src/app/models/data-entities/free-form-text-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-free-form-text-data-entity-view',
    templateUrl: './free-form-text-data-entity-view.component.html',
    styleUrls: ['./free-form-text-data-entity-view.component.css'],
    standalone: false
})
export class FreeFormTextDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  @Input() entity: FreeFormTextDataEntity;
  templateForPermitForm: boolean = false

  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
     //added by priya 16-12-2025

    layoutService.useNewLayout$.subscribe((useNewLayout) => {
      this.templateForPermitForm = useNewLayout;
    });
     //end by priya 16-12-2025
  }

  ngOnInit() {}
  // added by priya 17-12-2025
  getEntityLabelText(): string {
    if (!this.entity) {
      return '';
    }

    let label = this.showLabel ? this.entity.label : '';


    return label;
  }
  // end by priya 17-12-2025
}
